import type { useTranslations } from 'next-intl';
import { SITE } from '@/app/constants';

export const getVideoResources = (t: ReturnType<typeof useTranslations>) =>
  SITE === 'global'
    ? [
        {
          url: 'https://image01.cf.vidu.studio/vidu/landing-page/anime.9e7436b5.mp4',
          poster: 'https://image01.cf.vidu.studio/vidu/media-asset/creat2-9767a973.webp',
          mobilePoster: 'https://image01.cf.vidu.studio/vidu/media-asset/creat2-9767a973-a8016b33.webp',
          intlKey: 'item1',
          title: t('anime'),
        },
        {
          url: 'https://image01.cf.vidu.studio/vidu/landing-page/advertising.72394969.mp4',
          poster: 'https://image01.cf.vidu.studio/vidu/media-asset/creat4-3d0d2761.webp',
          mobilePoster: 'https://image01.cf.vidu.studio/vidu/media-asset/creat4-3d0d2761-fb381694.webp',
          intlKey: 'item2',
          title: t('advertising'),
        },
        {
          url: 'https://image01.cf.vidu.studio/vidu/landing-page/socialMedia.348ef153.mp4',
          poster: 'https://image01.cf.vidu.studio/vidu/media-asset/creat3-f3991d9c.webp',
          mobilePoster: 'https://image01.cf.vidu.studio/vidu/media-asset/creat3-f3991d9c-0a2fc14a.webp',
          intlKey: 'item3',
          title: t('socialMedia'),
        },
        {
          url: 'https://image01.cf.vidu.studio/vidu/landing-page/tourismGlobal.006a1326.mp4',
          poster: 'https://image01.cf.vidu.studio/vidu/media-asset/create6-0457bc8c.webp',
          mobilePoster: 'https://image01.cf.vidu.studio/vidu/media-asset/create6-0457bc8c-19881c33.webp',
          intlKey: 'item4',
          title: t('cultureTourism'),
        },
        {
          url: 'https://image01.cf.vidu.studio/vidu/landing-page/film.f3db79f8.mp4',
          poster: 'https://image01.cf.vidu.studio/vidu/media-asset/creat5-160f01fe.webp',
          mobilePoster: 'https://image01.cf.vidu.studio/vidu/media-asset/creat5-160f01fe-6d5364fa.webp',
          intlKey: 'item5',
          title: t('film'),
        },
      ]
    : [
        {
          url: 'https://image01.vidu.zone/vidu/landing-page/anime.1d688d50.mp4',
          poster: 'https://image01.vidu.zone/vidu/media-asset/creat2-9767a973.webp',
          mobilePoster: 'https://image01.vidu.zone/vidu/media-asset/creat2-9767a973-a8016b33.webp',
          intlKey: 'item1',
          title: t('anime'),
        },
        {
          url: 'https://image01.vidu.zone/vidu/landing-page/advertising.9d3ca821.mp4',
          poster: 'https://image01.vidu.zone/vidu/media-asset/creat4-3d0d2761.webp',
          mobilePoster: 'https://image01.vidu.zone/vidu/media-asset/creat4-3d0d2761-fb381694.webp',
          intlKey: 'item2',
          title: t('advertising'),
        },
        {
          url: 'https://image01.vidu.zone/vidu/landing-page/socialMedia.9fff05de.mp4',
          poster: 'https://image01.vidu.zone/vidu/media-asset/creat3-f3991d9c.webp',
          mobilePoster: 'https://image01.vidu.zone/vidu/media-asset/creat3-f3991d9c-0a2fc14a.webp',
          intlKey: 'item3',
          title: t('socialMedia'),
        },
        {
          url: 'https://image01.vidu.zone/vidu/landing-page/tourismChina.0cead14c.mp4',
          poster: 'https://image01.vidu.zone/vidu/media-asset/creat6-fa1a4a32.webp',
          mobilePoster: 'https://image01.vidu.zone/vidu/media-asset/creat6-fa1a4a32-525dca1d.webp',
          intlKey: 'item4',
          title: t('cultureTourism'),
        },
        {
          url: 'https://image01.vidu.zone/vidu/landing-page/film.54a7c837.mp4',
          poster: 'https://image01.cf.vidu.studio/vidu/media-asset/creat5-160f01fe.webp',
          mobilePoster: 'https://image01.cf.vidu.studio/vidu/media-asset/creat5-160f01fe-6d5364fa.webp',
          intlKey: 'item5',
          title: t('film'),
        },
      ];
